export default "__VITE_ASSET__pHwF3N5q__"